import $ from "jquery";
import { breakpoint } from "../breakpoint";

let throttler;

/*
 * SimpleAccordion
 * Simply a button that toggles the element that immediately follows it and sets appropriate aria values.
 * Can take "false" for activeIn to be active everywhere, or an array of breakpoints to be active
 *   in.  These need to match the breakpoint content values in the SCSS
 */
export class SimpleAccordion {
  constructor($el, activeIn) {
    this.$el = $el;
    this.activeIn = activeIn;
    this.$target = this.$el.next();

    /* Hide if for all devices, or if mobile only and in mobile mode */
    if ((this.activeIn && (this.activeIn.indexOf(breakpoint()) > -1)) || !this.activeIn) {
      this.$target.hide();
    }

    this.bindEvents();
  }

  bindEvents() {
    let thisAccordion = this;

    thisAccordion.$el.on("click", function() {
      let currAria = thisAccordion.$el.attr("aria-expanded");
      thisAccordion.$el.attr("aria-expanded", currAria === "false" ? "true" : "false");
      thisAccordion.$el.toggleClass("is-open");
      thisAccordion.$target.slideToggle();
    });

    $(window).on("resize", event => {
      if (throttler) {
        window.clearTimeout(throttler);
      }
      throttler = setTimeout(() => {
        thisAccordion.manageBreakpointBehaviors();
      }, 400);
    });
  }

  manageBreakpointBehaviors() {
    if ((this.activeIn && (this.activeIn.indexOf(breakpoint()) > -1)) || !this.activeIn) {
      this.$target.hide();
      this.$el.attr("aria-expanded", "false");
      this.$el.removeClass("is-open");
    }
    else {
      this.$target.show();
      this.$el.attr("aria-expanded", "true");
      this.$el.addClass("is-open");
    }
  }
}
